// @todo create a function to generate automatically theses properties
// authorized lets you know if the token is true or not
export default {
  distributors: state => state.distributors || [],
  distributor: state => state.distributor || null,
};
